import { Do, timer } from '../../universal';
import { $, _, showdown } from '../lib';
import { updateFacilityUI } from './component-facility-switcher';
import { IRIS } from './component-iris';
import { j2h } from './component-j2h';
import { sendErrorsToTelegram } from './component-main';
import { registerServiceWorker } from './component-sw-client';
import { to_is_locked, to_page_unlock } from './flyouts-old';
import { moment } from './moment-wrapper';
export const TOGLOB = {
    UPDATE_INTERVAL: 5000,
    onFlyoutsClose: null,
    showFlyoutAnimation: true,
    lockLevel: 0,
    timer_start: null,
    timers: [],
    converter: null,
};
export const testBrowser = (auto_msg) => {
    const valid = Do(() => {
        try {
            Array.from(new Set([1, 2, 3]));
            new Map([
                [1, 2],
                [3, 4],
            ]);
            _.assign({});
            JSON.parse('{}');
        }
        catch (error) {
            return false;
        }
        return true;
    });
    if (!valid && auto_msg) {
        $('#hub_content')
            .empty()
            .append(j2h({
            tag: 'p',
            html: `\
Your web browser is out of date and does not support viewing \
rosters. Please update your browser. If you are using iOS, \
ensure you are updated to the latest version available for your \
device.\
`,
        }));
    }
    return valid;
};
const to_initialise = () => {
    if (location.pathname !== '/roster/') {
        sendErrorsToTelegram();
    }
    {
        TOGLOB.$lock = [
            $(j2h({ ID: 'trionline_pagelock', class: 'toPageLock' })),
            $(j2h({ ID: 'trionline_pagelock_2', class: 'toPageLock' })),
            $(j2h({ ID: 'trionline_pagelock_3', class: 'toPageLock' })),
            $(j2h({ ID: 'trionline_pagelock_4', class: 'toPageLock' })),
            $(j2h({ ID: 'trionline_pagelock_5', class: 'toPageLock' })),
        ];
        const $b = $('body');
        TOGLOB.$lock.forEach(($x) => $b.append($x));
    }
    registerServiceWorker();
    refreshActivity();
    $(window).on({
        keyup: refreshActivity,
        mousemove: refreshActivity,
        click: refreshActivity,
        scroll: refreshActivity,
    });
    setsplit();
    TOGLOB.pageID = getPageID();
    updateUserTimer(true);
    setInterval(updateUserTimer, TOGLOB.UPDATE_INTERVAL);
    $(window).on('keydown', e => {
        if (e.which === 27 && to_is_locked()) {
            if (!TOGLOB.$lock[1].hasClass('locked')) {
                to_page_unlock();
            }
            else if (!TOGLOB.$lock[0].hasClass('locked')) {
                to_page_unlock();
            }
        }
        if (e.which === 114) {
            e.preventDefault();
            $('#hub_search_q').focus().select();
        }
        if (e.which === 192 && e.shiftKey === true) {
            if ($('#login').val() === '0') {
                return;
            }
            e.preventDefault();
            const $existing = $('#facility_picker_universal');
            if ($existing.length === 0) {
                updateFacilityUI();
            }
        }
    });
    $('#admin_choice').click(e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (!$(e.currentTarget).hasClass('inactive')) {
            updateFacilityUI();
        }
    });
    $('body').append($(j2h({
        tag: 'input',
        ID: 'to_page_load_timestamp',
        value: moment().unix() * 1000,
        attr: { type: 'hidden' },
    })));
    try {
        TOGLOB.converter = new showdown.Converter({
            headerLevelStart: 3,
            ghMentionsLink: '#mention',
        });
        TOGLOB.converter.setFlavor('github');
    }
    catch (error) { }
};
const setsplit = () => {
    TOGLOB.timer_start = Date.now();
};
export const clearSplits = () => {
    TOGLOB.timers = [];
    setsplit();
};
export const tsplit = (lbl) => {
    if (!TOGLOB.timers) {
        TOGLOB.timers = [];
    }
    const now = Date.now();
    const this_time = now - TOGLOB.timer_start;
    let total = undefined;
    total =
        TOGLOB.timers.length === 0
            ? this_time
            : now - TOGLOB.timers[0][1] + TOGLOB.timers[0][2];
    TOGLOB.timers.push([lbl, now, this_time, total]);
    setsplit();
};
export const gsplit = () => {
    if (console.table) {
        console.table(TOGLOB.timers);
    }
    else {
        $.each(TOGLOB.timers, (_index, data) => {
            console.log(data);
        });
    }
};
export const showBroadcastMessage = (msg) => {
    let footer = 'Click anywhere outside of the box to dismiss this message.';
    footer += ' We apologise for any inconvenience.';
    let click_enabled = false;
    $('body').append(j2h({
        class: 'trionline_broadcast_message',
        click: (_e, $elem) => {
            if (click_enabled) {
                $elem.remove();
            }
        },
        children: [
            {
                click: (e) => e.stopPropagation(),
                children: [
                    { class: 'heading', text: 'Message from System' },
                    { class: 'text', text: msg },
                    { class: 'footer', text: footer },
                ],
            },
        ],
    }));
    timer(1000, () => {
        click_enabled = true;
    });
};
const refreshActivity = () => {
    TOGLOB.lastActive = _.now();
};
let consecutiveRefreshRequests = 0;
const updateUserTimer = (is_first) => {
    if (['127.0.0.1', 'dev.localhost', '192.168.1.200'].includes(location.host)) {
        return;
    }
    const since_last_update = _.now() - TOGLOB.lastActive;
    consecutiveRefreshRequests -= 1;
    IRIS.Send({
        data: {
            progID: 0,
            funcID: 4,
            data: {
                req: location.href,
                width: window.innerWidth,
                height: window.innerHeight,
                initial: is_first ? 1 : 0,
                inactivity: since_last_update,
                page: TOGLOB.pageID,
            },
        },
        no: data => {
            const page = location.href.substring(location.host.length + location.protocol.length + 2);
            const basePage = page.split('?')[0]?.split('#')[0];
            const allowed = [
                '/',
                '/about/',
                '/about/features/',
                '/privacy/',
                '/acct/new-password/',
            ];
            if (_.includes(allowed, basePage)) {
                return;
            }
            if (data.message === 'Sign-In Required' && !window.allowIRISWithoutLogin) {
                consecutiveRefreshRequests += 2;
                if (consecutiveRefreshRequests > 6) {
                    console.info('Forcing page refresh from sign-in required');
                    location.reload();
                }
            }
        },
    });
};
export const applyLoadingUISmall = ($elem) => $elem.empty().append(j2h({
    tag: 'img',
    class: 'ajax_ico',
    attr: {
        src: '/static/img/ajax-loader.gif',
        alt: 'Loading...',
    },
}));
export const applyLoadingUILarge = ($elem) => {
    const $children = $elem.children();
    if ($children.length === 1 && $children.hasClass('loadingSpinnerLarge')) {
        return;
    }
    $elem.empty().append(j2h({
        class: 'loadingSpinnerLarge',
        children: [
            { class: 'circle blue' },
            { class: 'circle red' },
            { class: 'circle yellow' },
            { class: 'circle green' },
        ],
    }));
};
export const stdPulse = ($elem = $('body'), colour = '#ffa', duration = 200, callback = _.noop) => {
    let orig_transition = $elem.css('transition');
    let orig_bgcolour = $elem.css('background');
    orig_transition = '';
    orig_bgcolour = '';
    $elem.css('transition', `background ${duration / 1000}s`);
    $elem.css('background', colour);
    timer(duration, () => $elem.css('background', orig_bgcolour));
    timer(duration * 2, () => {
        $elem.css('transition', orig_transition);
        callback();
    });
};
export const tableSortable = ($table) => {
    $table.find('tr').each((x, elem) => {
        $(elem).attr('data-sort-key', x);
    });
    const $header_cells = $table.find('tr').first().addClass('sortable').children();
    $header_cells
        .addClass('noselect')
        .each((_i, elem) => {
        const $this = $(elem);
        if ($this.children().length === 1 && $this.children('span').length === 1) {
            return;
        }
        const text = $this.text();
        $this.html(`<span>${text}</span>`);
    })
        .off('click')
        .on('click', e => {
        let $table;
        const $cell = $(e.currentTarget);
        $table = $cell.closest('table');
        const col_index = $cell[0]?.cellIndex ?? 0;
        let order = $cell.attr('data-order');
        order = !order ? 1 : 3 - +order;
        $cell.attr('data-order', order);
        let sorting_data = [];
        const existing_sort_index = [];
        $table
            .find('tr')
            .slice(1)
            .each((_i, elem) => {
            let $cell;
            const $row = $(elem);
            const sortKey = Number($row?.attr('data-sort-key') ?? 0);
            $cell = $row.children().eq(col_index);
            let value = $cell.attr('data-sort-data');
            if (value === undefined) {
                if ($cell.children('abbr').length === 1) {
                    value = $cell.children('abbr').attr('title');
                }
                else if ($cell.children('input').length === 1) {
                    value = $cell.children('input').first().val();
                }
                else {
                    value = $cell.text();
                }
            }
            value = _.trim(value);
            sorting_data.push([sortKey, value]);
            existing_sort_index.push(sortKey);
        });
        const getDataType = (v) => {
            let dtype = undefined;
            if (parseFloat(String(v)).toString() === v && v.length > 0) {
                dtype = 'int';
            }
            else if (String(v).split('/').length === 3 &&
                [8, 10].indexOf(String(v).length) >= 0) {
                dtype = 'date';
            }
            else if (v === '$ -') {
                dtype = 'dollar';
            }
            else {
                dtype = 'string';
            }
            return dtype;
        };
        let data_type_test_value = undefined;
        try {
            data_type_test_value = sorting_data?.[0]?.[1] ?? '';
        }
        catch (error) {
            data_type_test_value = '';
        }
        let dtype = getDataType(data_type_test_value);
        const getDollarAmount = (v) => {
            if (v.charAt(0) === '-') {
                return 0 - parseFloat(v.substring(4).replace(',', ''));
            }
            else if (_.trim(v) === '$ -') {
                return 0.0;
            }
            return parseFloat(v.substring(2).replace(',', ''));
        };
        const stringToDate = (rawString) => {
            const s = rawString.split('/');
            const y = s[2];
            const m = s[1];
            const d = s[0];
            return `${y}-${m}-${d}`;
        };
        sorting_data.forEach((item, x) => {
            const key = item[0];
            const val = item[1];
            switch (dtype) {
                case 'int': {
                    sorting_data[x] = [key, parseFloat(String(val))];
                    break;
                }
                case 'dollar': {
                    sorting_data[x] = [key, getDollarAmount(String(val))];
                    break;
                }
                case 'date': {
                    sorting_data[x] = [key, stringToDate(String(val))];
                    break;
                }
            }
        });
        dtype = ['int', 'dollar'].indexOf(dtype) !== -1 ? 'numeric' : 'string';
        if (_ !== undefined) {
            sorting_data = _.sortBy(sorting_data, x => {
                if (x[1] === '') {
                    return 'zzzzzzzzzzzzzzzzz';
                }
                return x[1];
            });
        }
        else {
            sorting_data.sort((a, b) => {
                if (dtype === 'numeric') {
                    return Number(a[1]) - Number(b[1]);
                }
                if (_.isString(a[1]) && _.isString(b[1])) {
                    return a[1].localeCompare(b[1]);
                }
                return 0;
            });
        }
        if (order === 1) {
            sorting_data.reverse();
        }
        const new_sort_index = _.map(sorting_data, x => x[0]);
        existing_sort_index.reverse();
        if (JSON.stringify(new_sort_index) === JSON.stringify(existing_sort_index)) {
            order = 3 - +order;
            $cell.attr('data-order', order);
            new_sort_index.reverse();
        }
        const $header = $table.find('tr').first();
        new_sort_index.forEach(key => {
            const $row = $table.find(`tr[data-sort-key="${key}"]`);
            $header.after($row);
        });
        order = +order;
        $cell.parent().children().removeClass('sort_asc sort_dsc sorted');
        if (order === 1) {
            $cell.addClass('sort_asc sorted');
        }
        else if (order === 2) {
            $cell.addClass('sort_dsc sorted');
        }
    });
};
export const createTableRow = (fields) => $(j2h({
    tag: 'tr',
    children: fields.map(field => ({ tag: 'td', html: field })),
}));
export const newGrid = () => $(j2h({ class: 'grid' }));
export const createGridRow = (fields) => $(j2h({
    class: 'gridRow',
    children: fields.map(field => ({
        tag: 'span',
        class: 'gridCell',
        text: field,
        title: field,
    })),
}));
const myHashCode = (S) => {
    let hash = 0;
    let chr = undefined;
    if (S.length === 0) {
        return hash;
    }
    _.range(S.length).forEach(i => {
        chr = S.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        return (hash |= 0);
    });
    return hash;
};
const getPageID = () => {
    const s = Date.now().toString();
    return myHashCode(s);
};
export const addImageLightbox = ($container) => {
    $container.addClass('lightbox-container');
    const $all_images = $container.find('img:not(.nolightbox)');
    $all_images.off('click', openingImageLightbox);
    $all_images.on('click', openingImageLightbox);
};
const openingImageLightbox = (e) => {
    const $img = $(e.currentTarget);
    const img_query = 'img:not(.nolightbox)';
    const $all_images = $img.closest('.lightbox-container').find(img_query);
    const shiftImage = (delta) => {
        const curr_src = $('.image_lightbox').find(img_query).attr('src');
        const $curr = $all_images.filter(`[src='${curr_src}']`);
        let index = $all_images.index($curr);
        const old_index = index + 0;
        index += delta;
        if (index < 0) {
            index = 0;
        }
        if (index >= $all_images.length) {
            index = $all_images.length - 1;
        }
        if (index === old_index) {
            return;
        }
        const new_src = $all_images.eq(index).attr('src');
        $('.image_lightbox')
            .find(img_query)
            .attr('src', new_src ?? '');
    };
    $('body').append(j2h({
        class: 'image_lightbox',
        ev: {
            click: (_e, $el) => $el.remove(),
            keydown: (e, $el) => {
                switch (e.which) {
                    case 39: {
                        shiftImage(1);
                        break;
                    }
                    case 37: {
                        shiftImage(-1);
                        break;
                    }
                    case 27: {
                        $el.remove();
                        break;
                    }
                }
            },
        },
        attr: { tabindex: 1 },
        children: [
            {
                tag: 'img',
                attr: { src: $img.attr('src') },
            },
        ],
    }));
    $('body').find('.image_lightbox').focus();
};
export const trionlineAjax = (obj) => {
    if (obj == null) {
        obj = {};
    }
    if (obj.url == null) {
        obj.url = './';
    }
    obj.method = (obj.method ?? obj.type ?? 'GET').toUpperCase();
    const yes = obj.yes ?? obj.success ?? _.noop;
    const no = obj.no ?? obj.error ?? _.noop;
    const any = obj.any ?? _.noop;
    const paramsTemp = _.map(obj.data ?? {}, (v, k) => [
        encodeURIComponent(k),
        encodeURIComponent(v),
    ]);
    const paramsArray = _.map(paramsTemp, x => `${x[0]}=${x[1]}`);
    const params = paramsArray.join('&');
    if (params && obj.method === 'GET') {
        obj.url += `?${params}`;
    }
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
        if (xhttp.readyState === 4) {
            if (xhttp.status === 200) {
                any(xhttp);
                yes(xhttp.responseText ?? null);
            }
            else {
                any(xhttp);
                no(xhttp);
            }
        }
    };
    xhttp.open(obj.method, obj.url, true);
    _.forEach(obj.headers, (v, k) => {
        xhttp.setRequestHeader(k, v);
    });
    xhttp.setRequestHeader('Pragma', 'no-cache');
    if (obj.method === 'POST') {
        xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhttp.send(params);
    }
    else {
        xhttp.send();
    }
    return xhttp;
};
export const runeSpeedTestBroadcast = async (responseObj) => new Promise(runSpeedTest).then(result => {
    IRIS.Send({
        data: {
            progID: 0,
            funcID: 15,
            broadcastUser: responseObj.OriginConnection,
            kbps: result,
        },
    });
});
export const runSpeedTest = (resolve) => {
    const concurrent = 4;
    const size = 50000;
    const gzip_KB = 1090;
    const createRequestAttempt = async () => new Promise((resolve, reject) => {
        const start = new Date();
        trionlineAjax({
            url: `https://${location.host}/blankdata/${size}/`,
            no: data => {
                reject(data);
            },
            yes: data => {
                const overall_taken = new Date() - start;
                const server_taken = Number(data.split('|')[0] ?? 0);
                const http_taken = overall_taken - server_taken;
                const KBPS = Math.floor((gzip_KB / http_taken) * 1000);
                resolve(KBPS);
            },
        });
    });
    const promises = _.range(concurrent).map(async () => createRequestAttempt());
    Promise.all(promises).then(KBPS => {
        console.log(`Speed results: ${KBPS.join(', ')} - total: ${_.sum(KBPS)} KB/s`);
        resolve(_.sum(KBPS));
    });
    console.log('Running speed test...');
};
$(document).ready(to_initialise);
//# sourceMappingURL=component-trionline.js.map